import { Link } from "react-router-dom";
import { BookOpen, Play, Trash2 } from "lucide-react";
import type { Talk } from "../types";
import { formatDuration } from "../lib/format";
import { StatusPill } from "./StatusPill";

export function TalkCard({
  talk,
  onDelete
}: {
  talk: Talk;
  onDelete?: (talk: Talk) => void;
}) {
  const image = talk.posterUrl || talk.thumbnailUrl;
  const progress =
    talk.durationMs > 0
      ? Math.min(100, Math.round((talk.progressMs / talk.durationMs) * 100))
      : 0;

  return (
    <article className="talk-card">
      <Link to={`/talks/${talk.id}`} className="talk-card-visual">
        {image ? (
          <img src={image} alt="" loading="lazy" />
        ) : (
          <div className="talk-card-placeholder" aria-hidden="true">
            <span>T</span>
          </div>
        )}
        <span className="talk-card-shade" />
        <span className="talk-duration">
          <Play size={11} fill="currentColor" />
          {formatDuration(talk.durationMs, true)}
        </span>
        {talk.status === "ready" && (
          <span className="card-play" aria-hidden="true">
            <Play size={19} fill="currentColor" />
          </span>
        )}
        {progress > 0 && talk.status === "ready" && (
          <span className="card-progress">
            <i style={{ width: `${progress}%` }} />
          </span>
        )}
      </Link>
      <div className="talk-card-body">
        <div className="talk-card-meta">
          <StatusPill status={talk.status} stage={talk.stage} />
          <span className="talk-source">{talk.speaker}</span>
        </div>
        <div className="talk-card-titles">
          <Link to={`/talks/${talk.id}`} className="talk-card-title">
            {talk.title}
          </Link>
          {talk.titleZh && (
            <span className="talk-card-title-zh">{talk.titleZh}</span>
          )}
        </div>
        <div className="talk-card-foot">
          <span>
            {talk.status === "ready"
              ? progress > 0
                ? `已看 ${progress}%`
                : "尚未开始"
              : talk.status === "processing" || talk.status === "queued"
                ? `处理进度 ${talk.progress}%`
                : "查看处理详情"}
          </span>
          <div className="talk-card-actions">
            <Link
              to={`/talks/${talk.id}${talk.status === "ready" ? "" : ""}`}
              aria-label="打开学习页"
            >
              <BookOpen size={16} />
            </Link>
            {onDelete && (
              <button
                type="button"
                onClick={() => onDelete(talk)}
                aria-label="删除演讲"
              >
                <Trash2 size={15} />
              </button>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}

